import React, { useState } from 'react';
import { Send, CheckCircle, Phone, Mail, Package } from 'lucide-react';
import { translate } from '../i18n';
import { quoteFormspreeUrl } from '../formspree';

// Liste des pays avec indicatifs téléphoniques
const countries = [
  { name: 'Afghanistan', prefix: '+93' },
  { name: 'Allemagne', prefix: '+49' },
  { name: 'Algérie', prefix: '+213' },
  { name: 'Arabie Saoudite', prefix: '+966' },
  { name: 'Argentine', prefix: '+54' },
  { name: 'Australie', prefix: '+61' },
  
  { name: 'Bahreïn', prefix: '+973' },
  { name: 'Bangladesh', prefix: '+880' },
  { name: 'Belgique', prefix: '+32' },
  { name: 'Bhoutan', prefix: '+975' },
  { name: 'Birmanie', prefix: '+95' },
  { name: 'Bolivie', prefix: '+591' },
  { name: 'Brésil', prefix: '+55' },
  { name: 'Cambodge', prefix: '+855' },
  { name: 'Canada', prefix: '+1' },
  { name: 'Chili', prefix: '+56' },
  { name: 'Chine', prefix: '+86' },
  { name: 'Chypre', prefix: '+357' },
  { name: 'Colombie', prefix: '+57' },
  { name: 'Corée du Nord', prefix: '+850' },
  { name: 'Corée du Sud', prefix: '+82' },
  { name: 'Égypte', prefix: '+20' },
  { name: 'Émirats Arabes Unis', prefix: '+971' },
  { name: 'Équateur', prefix: '+593' },
  { name: 'Espagne', prefix: '+34' },
  { name: 'États-Unis', prefix: '+1' },
  { name: 'Fidji', prefix: '+679' },
  { name: 'France', prefix: '+33' },
  { name: 'Grèce', prefix: '+30' },
  { name: 'Guyana', prefix: '+592' },
  { name: 'Guyane Française', prefix: '+594' },
  { name: 'Hong Kong', prefix: '+852' },
  { name: 'Inde', prefix: '+91' },
  { name: 'Indonésie', prefix: '+62' },
  { name: 'Iran', prefix: '+98' },
  { name: 'Irak', prefix: '+964' },
  { name: 'Italie', prefix: '+39' },
  { name: 'Japon', prefix: '+81' },
  { name: 'Jordanie', prefix: '+962' },
  { name: 'Kiribati', prefix: '+686' },
  { name: 'Koweït', prefix: '+965' },
  { name: 'Laos', prefix: '+856' },
  { name: 'Liban', prefix: '+961' },
  { name: 'Libye', prefix: '+218' },
  { name: 'Macao', prefix: '+853' },
  { name: 'Malaisie', prefix: '+60' },
  { name: 'Maldives', prefix: '+960' },
  { name: 'Malte', prefix: '+356' },
  { name: 'Maroc', prefix: '+212' },
  { name: 'Mexique', prefix: '+52' },
  { name: 'Micronésie', prefix: '+691' },
  { name: 'Nauru', prefix: '+674' },
  { name: 'Népal', prefix: '+977' },
  { name: 'Nouvelle-Zélande', prefix: '+64' },
  { name: 'Oman', prefix: '+968' },
  { name: 'palestine', prefix: '+970' },
  { name: 'Pakistan', prefix: '+92' },
  { name: 'Palaos', prefix: '+680' },
  { name: 'Papouasie-Nouvelle-Guinée', prefix: '+675' },
  { name: 'Paraguay', prefix: '+595' },
  { name: 'Pérou', prefix: '+51' },
  { name: 'Philippines', prefix: '+63' },
  { name: 'Portugal', prefix: '+351' },
  { name: 'Qatar', prefix: '+974' },
  { name: 'Royaume-Uni', prefix: '+44' },
  { name: 'Singapour', prefix: '+65' },
  { name: 'Sri Lanka', prefix: '+94' },
  { name: 'Suriname', prefix: '+597' },
  { name: 'Suisse', prefix: '+41' },
  { name: 'Syrie', prefix: '+963' },
  { name: 'Taïwan', prefix: '+886' },
  { name: 'Thaïlande', prefix: '+66' },
  { name: 'Tonga', prefix: '+676' },
  { name: 'Tunisie', prefix: '+216' },
  { name: 'Turquie', prefix: '+90' },
  { name: 'Tuvalu', prefix: '+688' },
  { name: 'Uruguay', prefix: '+598' },
  { name: 'Vanuatu', prefix: '+678' },
  { name: 'Venezuela', prefix: '+58' },
  { name: 'Vietnam', prefix: '+84' },
  { name: 'Yémen', prefix: '+967' },
  { name: 'Îles Marshall', prefix: '+692' },
  { name: 'Îles Salomon', prefix: '+677' },
  { name: 'Autre', prefix: '' }
];

const Devis = ({ produits, usine, language }) => {
  const t = (text) => translate(language, text);
  const [formData, setFormData] = useState({
    societe: '',
    nom: '',
    email: '',
    telephone: '+216 ',
    pays: 'Tunisie',
    produit: '',
    quantite: '',
    unite: 'Tonnes',
    usage: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [phonePrefix, setPhonePrefix] = useState('+216');

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'telephone') {
      // Pour le téléphone, combiner le préfixe avec la valeur saisie
      const fullPhone = phonePrefix ? `${phonePrefix} ${value}` : value;
      setFormData({
        ...formData,
        [name]: fullPhone
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });

      // Mettre à jour le préfixe téléphonique quand le pays change
      if (name === 'pays') {
        const selectedCountry = countries.find(country => country.name === value);
        if (selectedCountry) {
          setPhonePrefix(selectedCountry.prefix);
          // Mettre à jour le numéro de téléphone avec le nouveau préfixe
          const currentNumber = formData.telephone.replace(/^\+\d+\s*/, '');
          setFormData(prev => ({
            ...prev,
            telephone: selectedCountry.prefix ? `${selectedCountry.prefix} ${currentNumber}` : currentNumber
          }));
        }
      }
    }
  };

  // Fonction de validation
  const validateForm = () => {
    const errors = [];

    // Validation email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      errors.push(t('Veuillez entrer une adresse email valide.'));
    }

    // Validation téléphone
    const phoneRegex = /^\+\d{1,4}\s*\d{6,15}$/;
    if (!phoneRegex.test(formData.telephone.replace(/\s/g, ''))) {
      errors.push(t('Veuillez entrer un numéro de téléphone valide avec l\'indicatif international.'));
    }

    // Validation société
    if (formData.societe.trim().length < 2) {
      errors.push(t('Le nom de la société doit contenir au moins 2 caractères.'));
    }

    // Validation nom
    if (formData.nom.trim().length < 2) {
      errors.push(t('Le nom complet doit contenir au moins 2 caractères.'));
    }

    // Validation produit
    if (!formData.produit) {
      errors.push(t('Veuillez sélectionner un produit.'));
    }

    // Validation quantité
    if (!formData.quantite || parseFloat(formData.quantite) <= 0) {
      errors.push(t('Veuillez entrer une quantité valide supérieure à 0.'));
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation du formulaire
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      setError(validationErrors.join(' '));
      return;
    }

    setLoading(true);
    setError('');

    const submissionData = {
      societe: formData.societe,
      nom: formData.nom,
      email: formData.email,
      telephone: formData.telephone,
      pays: formData.pays,
      produit: formData.produit,
      quantite: formData.quantite,
      unite: formData.unite,
      usage: formData.usage || 'Non spécifié',
      message: formData.message || 'Aucun message supplémentaire',
      _subject: `Demande de devis - ${formData.produit}`,
      _captcha: false
    };

    fetch(quoteFormspreeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(submissionData)
    })
    .then((response) => {
      if (process.env.NODE_ENV === 'development') {
        console.log('Formspree Response Status:', response.status);
      }
      return response.json().then(data => ({ status: response.status, data }));
    })
    .then(({ status, data }) => {
      if (process.env.NODE_ENV === 'development') {
        console.log('Formspree Response:', data);
        console.log('Devis envoyé avec succès via Formspree!');
      }
      if (status !== 200) {
        throw new Error(`Erreur Formspree: ${status} - ${data.message || 'Erreur inconnue'}`);
      }
      setSubmitted(true);
      setLoading(false);
      
      // Réinitialiser après 5 secondes
      setTimeout(() => {
        setFormData({
          societe: '',
          nom: '',
          email: '',
          telephone: '+216 ',
          pays: 'Tunisie',
          produit: '',
          quantite: '',
          unite: 'Tonnes',
          usage: '',
          message: ''
        });
        setSubmitted(false);
      }, 5000);
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development') {
        console.error('Erreur Formspree détaillée:', err);
        console.error('Message:', err.message);
      }
      setError(`${t('Erreur :')} ${err.message}. ${t('Veuillez vérifier votre connexion et réessayer ou nous contacter directement.')}`);
      setLoading(false);
    });
  };

  return (
    <div className="devis">
      {/* Header */}
      <section className="hero internal-hero devis-hero" style={{
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2)), url("/images/devis.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="container">
          <h1 className="hero-title">{t('Demande de devis DCP')}</h1>
          <p className="hero-subtitle">
            {t('Indiquez votre tonnage, destination et exigences qualité pour recevoir une proposition adaptée.')}
          </p>
        </div>
      </section>

      {/* Formulaire */}
      <section className="section" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #f0f4f8 100%)' }}>
        <div className="container">
          {submitted ? (
            <div className="devis-success-shell" style={{
              maxWidth: '800px',
              margin: '0 auto',
              backgroundColor: 'white',
              borderRadius: '16px',
              padding: '50px 40px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
              textAlign: 'center'
            }}>
              <div className="devis-success-icon" style={{ 
                width: '100px', 
                height: '100px', 
                background: 'linear-gradient(135deg, #00A4E4, #5B2E96)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 30px',
                boxShadow: '0 8px 25px rgba(40, 167, 69, 0.3)',
                animation: 'successPulse 2s infinite'
              }}>
                <CheckCircle size={50} color="white" />
              </div>
              <h2 style={{ color: '#5B2E96', marginBottom: '15px', fontSize: '32px', fontWeight: '700' }}>
                {t('Demande Envoyée avec Succès !')}
              </h2>
              <p style={{ color: '#666', fontSize: '18px', marginBottom: '10px' }}>
                {t('Merci')} <strong style={{ color: '#5B2E96' }}>{formData.nom}</strong> {t('de votre intérêt pour Phosphokym.')}
              </p>
              <p style={{ color: '#666', fontSize: '16px', marginBottom: '30px' }}>
                {t('Votre demande a été envoyée à notre équipe commerciale.')}
                <br />
                {t('Nous vous contacterons sous')} <strong>24h</strong> {t('à :')}<br />
                <span style={{ color: '#00A4E4', fontWeight: '600', fontSize: '18px' }}>{formData.email}</span>
              </p>
              
              <div className="devis-success-summary" style={{ 
                background: 'linear-gradient(135deg, #e8f5e8, #f0f9f0)', 
                padding: '30px', 
                borderRadius: '12px',
                margin: '30px auto',
                border: '1px solid #d4edda',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)'
              }}>
                <h4 style={{ color: '#28a745', marginBottom: '20px', fontSize: '18px', fontWeight: '700' }}>
                  <Package size={20} style={{ marginRight: '10px' }} />
                  {t('Récapitulatif de votre demande')}
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                  <div style={{ textAlign: 'left' }}>
                    <p style={{ margin: '8px 0', fontSize: '15px' }}>
                      <strong style={{ color: '#0A2E5C' }}>{t('Société :')}</strong> {formData.societe}
                    </p>
                    <p style={{ margin: '8px 0', fontSize: '15px' }}>
                      <strong style={{ color: '#0A2E5C' }}>{t('Produit :')}</strong> {formData.produit}
                    </p>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <p style={{ margin: '8px 0', fontSize: '15px' }}>
                      <strong style={{ color: '#0A2E5C' }}>{t('Quantité :')}</strong> {formData.quantite} {t(formData.unite)}
                    </p>
                    {formData.usage && formData.usage !== 'Non spécifié' && 
                      <p style={{ margin: '8px 0', fontSize: '15px' }}>
                        <strong style={{ color: '#0A2E5C' }}>{t('Usage :')}</strong> {t(formData.usage)}
                      </p>
                    }
                  </div>
                </div>
              </div>
              
              <p style={{ color: '#666', fontSize: '14px', marginTop: '20px' }}>
                 {t('Vous recevrez également une copie de cette demande par email.')}
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="devis-form-shell contact-rfq-form" style={{
              maxWidth: '900px',
              margin: '0 auto',
              backgroundColor: 'white',
              borderRadius: '16px',
              padding: '50px 40px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)'
            }}>
              <div className="devis-form-intro" style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h2 style={{ color: '#0A2E5C', fontSize: '32px', fontWeight: '700', marginBottom: '10px' }}>
                  {t('Demande de Devis Personnalisé')}
                </h2>
                <p style={{ color: '#666', fontSize: '16px' }}>
                  {t('Remplissez ce formulaire pour recevoir un devis adapté à vos besoins')}
                </p>
              </div>

              {error && (
                <div style={{ 
                  background: 'linear-gradient(135deg, #f8d7da, #fadbd8)', 
                  color: '#721c24', 
                  padding: '20px',
                  borderRadius: '12px',
                  marginBottom: '30px',
                  border: '1px solid #f5c6cb',
                  boxShadow: '0 4px 15px rgba(247, 215, 218, 0.3)'
                }}>
                  <strong>{t('Erreur :')}</strong> {error}
                </div>
              )}

              {/* Informations Client */}
              <div className="devis-form-section" style={{ marginBottom: '40px' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '25px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #00A4E4'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: '#00A4E4',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '16px'
                  }}>
                    1
                  </div>
                  <h3 style={{ color: '#0A2E5C', fontSize: '22px', fontWeight: '600', margin: 0 }}>
                    {t('Informations Client')}
                  </h3>
                </div>

                <div className="devis-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                  <div className="form-group">
                    <label style={{ 
                      color: '#0A2E5C', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      {t('Société *')}
                    </label>
                    <input
                      type="text"
                      name="societe"
                      value={formData.societe}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #e9ecef',
                        borderRadius: '8px',
                        fontSize: '15px',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                      required
                      placeholder={t('Nom de votre entreprise')}
                    />
                  </div>

                  <div className="form-group">
                    <label style={{ 
                      color: '#0A2E5C', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      {t('Nom & Prénom *')}
                    </label>
                    <input
                      type="text"
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #e9ecef',
                        borderRadius: '8px',
                        fontSize: '15px',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                      required
                      placeholder={t('Votre nom complet')}
                    />
                  </div>
                </div>

                <div className="devis-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '20px' }}>
                  <div className="form-group">
                    <label style={{ 
                      color: '#0A2E5C', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      {t('Email *')}
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #e9ecef',
                        borderRadius: '8px',
                        fontSize: '15px',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                      required
                      placeholder={t('nom@exemple.com')}
                    />
                  </div>

                  <div className="form-group">
                    <label style={{ 
                      color: '#0A2E5C', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      {t('Téléphone *')}
                    </label>
                    <div style={{ display: 'flex', alignItems: 'stretch' }}>
                      <div style={{
                        padding: '14px 12px',
                        backgroundColor: '#f8f9fa',
                        border: '2px solid #e9ecef',
                        borderRight: 'none',
                        borderRadius: '8px 0 0 8px',
                        fontSize: '15px',
                        fontWeight: '600',
                        color: '#0A2E5C',
                        width: '90px',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {phonePrefix}
                      </div>
                      <input
                        type="tel"
                        name="telephone"
                        value={formData.telephone.replace(/^\+\d+\s*/, '')}
                        onChange={handleChange}
                        style={{
                          flex: 1,
                          padding: '14px 16px',
                          border: '2px solid #e9ecef',
                          borderLeft: 'none',
                          borderRadius: '0 8px 8px 0',
                          fontSize: '15px',
                          transition: 'all 0.3s ease',
                          outline: 'none',
                          minWidth: 0
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                        onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                        required
                        placeholder={t('votre numéro de téléphone')}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: '20px' }}>
                  <label style={{ 
                    color: '#0A2E5C', 
                    fontWeight: '600', 
                    fontSize: '14px',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    {t('Pays *')}
                  </label>
                  <select
                    name="pays"
                    value={formData.pays}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      maxWidth: '300px',
                      padding: '14px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '15px',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    required
                  >
                    {countries.map(country => (
                      <option key={country.name} value={country.name}>
                        {t(country.name)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Demande Spécifique */}
              <div className="devis-form-section" style={{ marginBottom: '40px' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '25px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #00A4E4'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: '#00A4E4',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '16px'
                  }}>
                    2
                  </div>
                  <h3 style={{ color: '#0A2E5C', fontSize: '22px', fontWeight: '600', margin: 0 }}>
                    {t('Demande Spécifique')}
                  </h3>
                </div>

                <div style={{ marginBottom: '25px' }}>
                  <label style={{ 
                    color: '#0A2E5C', 
                    fontWeight: '600', 
                    fontSize: '14px',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    {t('Produit souhaité *')}
                  </label>
                  <select
                    name="produit"
                    value={formData.produit}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '15px',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    required
                  >
                    <option value="">{t('Sélectionnez un produit')}</option>
                    {produits.map(produit => (
                      <option key={produit.nomFr || produit.nom} value={produit.nomFr || produit.nom}>
                        {produit.nom} ({produit.formule}) - {produit.concentration} - {produit.emballage}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                  <div>
                    <label style={{ 
                      color: '#0A2E5C', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      {t('Quantité *')}
                    </label>
                    <div className="devis-quantity-row" style={{ display: 'flex', gap: '10px' }}>
                      <input
                        type="number"
                        name="quantite"
                        value={formData.quantite}
                        onChange={handleChange}
                        style={{
                          flex: 1,
                          padding: '14px 16px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '15px',
                          transition: 'all 0.3s ease',
                          outline: 'none'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                        onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                        placeholder={t('Volume')}
                        min="0"
                        step="0.1"
                        required
                      />
                      <select
                        className="unit-select"
                        name="unite"
                        value={formData.unite}
                        onChange={handleChange}
                        style={{
                          width: '130px',
                          padding: '14px 16px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '15px',
                          transition: 'all 0.3s ease',
                          outline: 'none',
                          backgroundColor: 'white'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                        onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                      >
                        <option value="Tonnes">{t('Tonnes')}</option>
                        <option value="Big bags">{t('Big bags')}</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label style={{ 
                      color: '#0A2E5C', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      {t('Usage industriel')}
                    </label>
                    <select
                      name="usage"
                      value={formData.usage}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #e9ecef',
                        borderRadius: '8px',
                        fontSize: '15px',
                        transition: 'all 0.3s ease',
                        outline: 'none',
                        backgroundColor: 'white'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    >
                      <option value="">{t('Sélectionnez...')}</option>
                      <option value="Volaille">{t('Nutrition avicole')}</option>
                      <option value="Bovins et ruminants">{t('Bovins et ruminants')}</option>
                      <option value="Aquaculture">{t('Aquaculture')}</option>
                      <option value="Distribution agricole">{t('Distribution agricole')}</option>
                      <option value="Autre">{t('Autre')}</option>
                    </select>
                  </div>
                </div>

                <div style={{ marginTop: '25px' }}>
                  <label style={{ 
                    color: '#0A2E5C', 
                    fontWeight: '600', 
                    fontSize: '14px',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    {t('Informations complémentaires')}
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '15px',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      resize: 'vertical',
                      minHeight: '100px',
                      fontFamily: 'inherit'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#00A4E4'}
                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    placeholder={t('Spécifications techniques, délais, conditionnement particulier...')}
                    rows="4"
                  />
                </div>
              </div>

              {/* Engagement */}
              <div className="devis-engagement" style={{ 
                background: 'linear-gradient(135deg, #e8f4f8, #f0f9ff)', 
                padding: '25px',
                borderRadius: '12px',
                margin: '30px 0',
                border: '1px solid #d1e8f0'
              }}>
                <p style={{ color: '#0A2E5C', fontSize: '15px', textAlign: 'center', margin: 0 }}>
                  <strong>{t('Engagement Phosphokym :')}</strong> {t('Devis personnalisé sous 24h • Produits certifiés ISO 22000 • Support technique inclus')}
                </p>
              </div>

              {/* Bouton Submit */}
              <div className="devis-submit" style={{ textAlign: 'center', marginBottom: '40px' }}>
                <button className="btn btn-primary" type="submit" disabled={loading}>
                  {loading ? (
                    <span>{t('Envoi en cours...')}</span>
                  ) : (
                    <>
                      <Send size={22} />
                      {t('Envoyer ma demande de devis')}
                    </>
                  )}
                </button>
              </div>
              {/* Contact Direct */}
              <div style={{ textAlign: 'center', paddingTop: '30px', borderTop: '1px solid #e9ecef' }}>
                <p style={{ color: '#666', fontSize: '15px', marginBottom: '15px' }}>
                   {t('Contact direct disponible')}
                </p>
                <div className="devis-contact-row" style={{ 
                  display: 'flex', 
                  gap: '30px', 
                  justifyContent: 'center', 
                  flexWrap: 'wrap'
                }}>
                  <a 
                    href={`tel:${usine.telephone.replace(/\s+/g, '')}`}
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '10px', 
                      color: '#007BFF',
                      fontSize: '15px',
                      fontWeight: '500',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#0056b3'}
                    onMouseLeave={(e) => e.target.style.color = '#007BFF'}
                  >
                    <Phone size={18} />
                    <span>{usine.telephone}</span>
                  </a>
                  <a 
                    href={`mailto:${usine.commercial}`}
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '10px', 
                      color: '#007BFF',
                      fontSize: '15px',
                      fontWeight: '500',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#0056b3'}
                    onMouseLeave={(e) => e.target.style.color = '#007BFF'}
                  >
                    <Mail size={18} />
                    <span>{usine.commercial}</span>
                  </a>
                </div>
              </div>
            </form>
          )}
        </div>
      </section>
    </div>
  );
};

export default Devis;
